import React, { useContext } from 'react'
import CardContext from 'context/card'
import classNames from 'classnames'

const Title = () => {
    const props = useContext(CardContext)
    
    const {
        logo,
        product,
        titleClassName,
        titleStyle
    } = props

    const title = product ? product?.name :
        props?.name ? props?.name :
        props?.title ? props?.title :
        'Title'

    if(logo) {
        return (
            <img src={logo} alt='' style={{ height: 24, maxWidth: '100%', }} />
        )
    }
    return(
        <p
            className={classNames('title', titleClassName)}
            style={titleStyle}
        >
            {title.replace('Rane ', '')}
        </p>
    )
}

export default Title
